import { post } from '@/axios'

export interface IFinishTaskRequest {
  completed_period: number
  completed_times: number
  trigger_event: string
}

export const postFinishTask = async (params: IFinishTaskRequest) => {
  const response = await post<null>(`/taskApi/userTask/finishTask`, params)

  return response
}
